import { LitElement, html, css } from 'lit';
import { auth } from '../services/auth.js';

class AuthScreen extends LitElement {
  static styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background: #F9FAFB;
    }
    .card {
      background: white;
      border-radius: 1rem;
      box-shadow: 0 10px 25px -5px rgb(0 0 0 / 0.1);
      padding: 3rem;
      text-align: center;
      max-width: 24rem;
      width: 100%;
      margin: 1rem;
    }
    h1 { margin: 0 0 0.5rem; font-size: 1.875rem; font-weight: 700; color: #111827; }
    p { margin: 0 0 2rem; color: #6B7280; }
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
      width: 100%;
      padding: 0.75rem 1.5rem;
      background: white;
      border: 1px solid #D1D5DB;
      border-radius: 0.5rem;
      font-size: 1rem;
      font-weight: 500;
      color: #374151;
      cursor: pointer;
      transition: background-color 0.15s;
    }
    button:hover { background: #F9FAFB; }
    svg { width: 1.25rem; height: 1.25rem; }
  `;

  _signIn() {
    auth.signInWithGoogle();
  }

  render() {
    return html`
      <div class="card">
        <h1>Meal Planner</h1>
        <p>Plan your weekly meals, generate shopping lists, and track your budget.</p>
        <button @click=${this._signIn}>
          <svg viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Sign in with Google
        </button>
      </div>
    `;
  }
}

customElements.define('auth-screen', AuthScreen);
